import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import cx from 'classnames';

const PageTabs = ({ tabs = [], wrapperStyles }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const pathnameTabIndex = tabs.findIndex(({ url }) => url.indexOf(pathname) > -1);
  return (
    <>
      <div className={'react-tabs'} style={wrapperStyles}>
        <ul className="react-tabs__tab-list" role={'tablist'}>
          {tabs.map(({ url, label, isActive }, index) => {
            return (
              <li
                role={'tab'}
                key={index}
                onClick={() => {
                  navigate(url);
                }}
                className={cx('react-tabs__tab', { 'react-tabs__tab--selected': isActive ?? pathnameTabIndex === index })}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default memo(PageTabs);
